<template>
    <div id="contendor-principal-anexo">
        <div id="contenedor-encabezados-anexo" class="text-left">
            <h1>CÉDULA DE EXPEDIENTE</h1>
            <h3>Ingrese la información paga generar el anexo</h3>
        </div>
        <div id="contendor-anexo" class="mt-4 d-flex col-12 area">
           <div id="contenedor-datos-anexos" class="col-4">
                <div id="informacion-anexo" class="contenedor-color-negro">
                    <h5>Formulario de anexo</h5>
                    <hr />
                    <div class="form-group mt-4">
                        <h6>Archivo que se desea anexar</h6>
                        <input type="file" id="archivo_anexo" class="form-control" v-on:change="eventoCargaArchivo($event)" accept=".PDF,.JPG,.JPEG" />
                    </div>
                    <div class="form-group">
                        <h6>Nombre del Anexo</h6>
                        <input v-model="nombreAnexo" type="text" class="form-control" placeholder="Ingrese el nombre del anexo"/>
                    </div>
                    <div class="form-group">
                        <h6>Descripcion del anexo</h6>
                        <textarea v-model="descripcionAnexo" rows="4" type="text" class="form-control" placeholder="Ingrese la descripcion del anexo"/>
                    </div>
                     <div style="margin-top: 2em;" class="d-flex justify-content-between">
                        <button type="button" @click="regresarVistaAnterior" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left"></i></button>
                        <button type="button" class="btn btn-primary"><i class="fas fa-paperclip"></i>&nbsp;&nbsp;Anexar</button>
                    </div> 
                </div>
                <div id="anexos-anteriores" class="contenedor-color-negro mt-3">
                    <h5>Anexos anteriores</h5>
                    <hr />
                    <div class="form-group">
                        <div class="contenedor-anexos">
                            <div v-if="anexos.length < 1" class="w-100 h-100 d-flex align-items-center justify-content-center">
                                <h5>Sin anexos</h5>
                            </div>
                            <div v-for="(anexo,index) in anexos" :class="[index == 0 ? 'anexos d-flex' : 'anexos d-flex mt-2']" :key="anexo + index">
                                <label>{{anexo.nombre}}</label>
                                <div>
                                    <button type="button" class="btn-sm btn-primary" disabled><i class="fas fa-paperclip"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
           <div class="col-8 contenedor-color-negro">
                <h5>Documento</h5>
                <hr />
                <div>
                    <div id="visor_contenedor">
                        <div id="visor">
                            <object v-if="cargoDocumentoPDF" :data="urlPdf" type="application/pdf" :height="height"></object>
                            <object v-if="cargoDocumentoIMG" :data="urlPdf" type="image/jpg" :height="height"></object>
                            <label v-if="!cargoDocumentoPDF && !cargoDocumentoIMG">{{mensajeVisor}}</label>          
                        </div>
                    </div>  
                </div>
           </div>
        </div>
    </div>
</template>
<script>
import comun from '@/../static/js/comun'
import router from '@/router/index'

export default {
    data() {
        return {
            mostrarDocumento: false,
            nombreAnexo: '',
            descripcionAnexo: '',
            archivoDeAnexo: null,
            anexos: [
                {id:1, nombre: 'anexo 1'},
                {id:2, nombre: 'anexo 2'},
                {id:3, nombre: 'anexo 3'},
                {id:4, nombre: 'anexo 4'}
            ],
            height: '655px',
            url: '',
            mensajeVisor: 'No se encuentra ningun archivo seleccionado.',
            cargoDocumentoPDF: false,
            cargoDocumentoIMG: false,
            urlPdf: ''
        }
    },
    methods: {
        eventoCargaArchivo: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.archivoDeAnexo = evento.target.files[0];
                    this.elegirTipoDeRecurso(this.archivoDeAnexo);
                    this.mensajeVisor = 'No hay ruta de archivo. Favor de volver a intentar.'
                }
                else {
                    this.archivoDeAnexo = false;
                    this.cargoDocumentoPDF = false;
                    this.cargoDocumentoIMG = false;
                    this.mensajeVisor = 'El documento no se cargo correctamente.'
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        elegirTipoDeRecurso: function(archivo) {
            switch(archivo.type) {
                case 'application/pdf':
                    this.cargoDocumentoPDF = true;
                    this.cargoDocumentoIMG = false;
                    this.urlPdf = URL.createObjectURL(archivo);
                break;
                case 'image/jpeg':
                    this.cargoDocumentoPDF = false;
                    this.cargoDocumentoIMG = true;
                    this.urlPdf = URL.createObjectURL(archivo);
                break;
                default:
            }
        },
        regresarVistaAnterior: function() {
            router.push({ name: "EdicionResultado" });
        }
    }
}
</script>
<style scoped>
    .contenedor-color-negro {
        padding: 1.5em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }

    textarea {
        padding: 0.6em !important;
    }

     .contenedor-anexos {
        background-color: #242425;
        max-height: 16em;
        height: 15.6em;
        overflow-y: auto;
        padding: 8px;
        border-radius: 4px;
    }

    .btn-sm {
        width: 25px;
        height: 25px;
        padding: 0;
    }

    .anexos {
        padding: 0.5em;
        background-color: #504f54;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .btn-primary:disabled{
        background-color: #666666; 
    }

    #visor_contenedor {
        flex: 1;
        background: #eee;
        overflow: auto;
    }

    #visor {
        width: 100%;
        margin: 0px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    #visor > div {
        text-align: center;
        max-width: 100%;
    }

    #visor object {
      width: 100%;      
      box-shadow: 0 2px 5px gray;
    }

    #visor label {
      width: 100%;
      color:black ;      
      text-align:center;
    }

</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/Resultados/Edicion/CAnexo.vue